import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    planogram(planoId) {
        console.assert(typeof planoId === "number");

        return http.get(buildUrlFromLocation(`/plano/${planoId}/lock`));
    }
};



// WEBPACK FOOTER //
// ./src/services/lock.js